import * as core from '../../../../../../../core'

import { query } from './outstanding-impacts-by-priority.query'

export const RESOURCE = {
  payload: {
    alias: 'outstanding.impacts.by.priority',
    description: 'Chart view of outstanding change impacts by priority',
    name: 'Outstanding Impacts by Priority',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
